import { render, staticRenderFns } from "./TakeAway.vue?vue&type=template&id=2030e6f6&lang=html"
import script from "./TakeAway.vue?vue&type=script&lang=js"
export * from "./TakeAway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports